import React from 'react';

const ReviewsHeaderSkeleton: React.FC = () => {
    return (
        <div className="flex items-center justify-between w-full p-6 border-b border-light-gray reviews rounded bg-gradient-to-r from-gray-200 to-gray-300 animate-pulse">
            <div className="flex gap-[20px]">
                {[1, 2, 3].map(index => (
                    <div
                        key={index}
                        className="flex items-center gap-[24px] bg-white bg-opacity-30 p-[10px] rounded-[12px]"
                    >
                        <div className="w-[36px] h-[36px] bg-gray-300 rounded-[6px]"></div>
                        <div className="h-6 bg-gray-300 rounded w-8"></div>
                        <div className="flex flex-col gap-2">
                            <div className="h-4 bg-gray-300 rounded w-20"></div>
                            <div className="h-3 bg-gray-300 rounded w-24"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewsHeaderSkeleton;
